<!-- Desktop: tab menu at top -->
<ng-container *ngIf="AppResolutionType !== ResolutionType.Mobile">
  <div class="tabmenu-container">
    <p-tabMenu class="businessDetails" [model]="items" [activeItem]="activeItem"
        (activeItemChange)="activeItem = $event">
    </p-tabMenu>
  </div>
  <div class="buttonBackToBusiness"> 
    <button class="back-button" pButton type="button" [icon]="icon" styleClass="p-button-secondary"
        (click)="backToAllBusinesses()">
    </button>
  </div>
  <div class="scrollable-content">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<!-- Mobile: content + bottom nav -->
<ng-container *ngIf="AppResolutionType === ResolutionType.Mobile">
  <button class="back-btn-mobile" pButton type="button" [icon]="icon"
      (click)="backToAllBusinesses()">
  </button>
  <div class="mobile-content">
    <router-outlet></router-outlet>
  </div>
  <nav class="mobile-bottom-nav">
    <button *ngFor="let item of navItems"
      class="nav-item"
      [class.active]="activeRoute === item.route"
      (click)="navigateTo(item.route)">
      <i [class]="item.icon"></i>
      <span>{{ item.labelKey | translate }}</span>
    </button>
  </nav>
</ng-container>